import { Component, Inject, Optional } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
    templateUrl:'./fund-minimums-component.html',
})

export class FundMinimumsComponent {
    
    constructor(public dialogRef: MatDialogRef<FundMinimumsComponent>,@Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    }

    closeDialog() {
        this.dialogRef.close();
    }
    
}